import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import spartaInputErrorUtility from '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { numericInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":42,"column":11}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <form novalidate>\r\n      <div class=\"row"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"topMargin") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":21},"end":{"line":4,"column":66}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"bottomMargin") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":66},"end":{"line":5,"column":53}}})) != null ? stack1 : "")
    + "\">\r\n        <div class=\"small-12 column flex-container "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"centerOnSmall") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":51},"end":{"line":7,"column":57}}})) != null ? stack1 : "")
    + "\">\r\n          <div class=\"input-caption\">\r\n            "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"inputCaption") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n          </div>\r\n          <div class=\"input-box\">\r\n            "
    + ((stack1 = (lookupProperty(helpers,"numericInput")||(depth0 && lookupProperty(depth0,"numericInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputBox") : depth0),{"name":"numericInput","hash":{},"data":data,"loc":{"start":{"line":12,"column":12},"end":{"line":12,"column":44}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n          <div class=\"sparta-button\">\r\n            "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"button") : depth0),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":15,"column":12},"end":{"line":15,"column":34}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </form>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"layerContent") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":4},"end":{"line":41,"column":13}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    return " top-margin";
},"5":function(container,depth0,helpers,partials,data) {
    return " bottom-margin";
},"7":function(container,depth0,helpers,partials,data) {
    return "center-on-small";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"id") : depth0),"==","zipSelectModal",{"name":"compare","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":6},"end":{"line":40,"column":18}}})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"layerContent","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":8},"end":{"line":39,"column":25}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" data-options='{\"type\":\"modal\"}'>\r\n            <div class=\"content\">\r\n              <form id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Form\" name=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Form\" autocomplete=\"off\" novalidate>\r\n                <p id=\"zipParagraph\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"paragraphText") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n                <div class=\"input-wrapper flex-container\">\r\n                  <div class=\"modal-input-box\">\r\n                    "
    + ((stack1 = (lookupProperty(helpers,"numericInput")||(depth0 && lookupProperty(depth0,"numericInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputBox") : depth0),{"name":"numericInput","hash":{},"data":data,"loc":{"start":{"line":30,"column":20},"end":{"line":30,"column":52}}})) != null ? stack1 : "")
    + "\r\n                  </div>\r\n                  <div class=\"modal-buttons\">\r\n                    "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"button") : depth0),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":33,"column":20},"end":{"line":33,"column":42}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"LINKS") : depths[1])) != null ? lookupProperty(stack1,"cancelLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":33,"column":43},"end":{"line":33,"column":78}}})) != null ? stack1 : "")
    + "\r\n                  </div>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"includeZipCodeModule") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":43,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/zip-code-cc-module",
  "version": "3.0.0",
  "id": "zipCodeCcModule",
  "containerID": "creditCardsZipCodeCcModule",
  "moduleName": "credit-cards-zip-code-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "zip-code-cc-module",
  "data": {
    "init": "ZipCodeCcModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "bottomMargin",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter applies bottom margin"
  }, {
    "name": "topMargin",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter applies top margin"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        link,
        layerContent,
        numericInput
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    link,
    layerContent,
    numericInput
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-global-functions-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-global-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-input-error-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global Manager spaParams sparta bactm */

/**
 * Implementation of the zip-code-cc-module module.
 * @copyright 2018-3-14
 * @since 3/14/2018, 3:40:39 PM
 * @author removed
 * @file
 */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["setZipCodeOnEnterKey"] }] */

const MARKET_COOKIE_CLEAR = 1e-10;
const {
  marketExpAreas
} = spaParams.siteParams;

/**
 * The ZipCodeCcModule Sparta Module.
 * Sets or updates local storage zip code and market cookie
 * @export
 * @class
 */
class ZipCodeCcModule extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {undefined}
   */
  init() {
    // Don't execute any code if includeZipCodeModule site param is not set to true
    if (spaParams.siteParams.includeZipCodeModule) {
      this.subscribeEvents();
      const {
        spartaGetCookie
      } = spartaGlobalFunctions;
      this.Validation = spartaValidationFramework.fn.core;
      const {
        zipStoreName,
        marketOptOutName,
        marketExpCookieName
      } = spaParams.siteParams;
      Object.assign(this, {
        zipStoreName,
        marketOptOutName,
        marketExpCookieName
      });
      this.isMarketPage = spaParams.pageParams.pageID === 'category-market-expansion';
      this.isRefferingFromMarketPage = document.referrer.includes('/credit-cards/market/');
      this.ccZipStoreVal = spartaStoreUtility.getPersisted(this.zipStoreName) ? spartaStoreUtility.getPersisted(this.zipStoreName) : '';
      this.marketOptOutValue = spartaStoreUtility.getPersisted(this.marketOptOutName) ? spartaStoreUtility.getPersisted(this.marketOptOutName) : false;
      this.zipSuppressVal = '00000';

      // Checks for the boa_geographic_data cookie and uses the stored zip
      const geoCookieZip = ZipCodeCcModule.checkForGeoCookie();
      if (geoCookieZip && !this.isMarketPage && this.ccZipStoreVal !== this.zipSuppressVal) {
        this.storeZipInLocalStorage(geoCookieZip);
        this.ccZipStoreVal = geoCookieZip;
        this.getAreaForZip(geoCookieZip);
      }
      this.marketCookieValue = spartaGetCookie(this.marketExpCookieName);
      this.target = this.settings.target;
      this.cookieExpiryTime = 360;
      this.initZipCodeModal();
      this.bindHandlers();
      this.initChickenSwitch();

      // Check for showZipModal=true URL param for other card pages to display this.
      if (this.SpartaFunctions.getUrlParam('showZipModal') === 'true') {
        ZipCodeCcModule.openZipCodeModal();
      }
    } else {
      // Clear out cookie and local storage, and redirect to home if on market page.
      this.unsetMarketAreaCookie();
      this.unsetZipStorage();
      setTimeout(() => {
        this.marketRedirectToHome();
      }, 0);
    }
  }

  /**
   * Bind non-zip modal related handlers
   * @returns {void}
   */
  bindHandlers() {
    this.bindValidationRules();
    this.target.addEventListener('submit', e => {
      e.preventDefault();
    });
  }

  /**
   * Initialize zip code modal and its buttons/fields
   * @return {undefined}
   */
  initZipCodeModal() {
    // Check for '00000' and clear the input field
    if (this.checkIfZipSuppressed()) this.setZipInputField('', false);

    // Get modal element selectors
    const cancelButton = document.getElementById('modalZipCodeCancelLink');
    const submitButton = document.getElementById('go-button-zip-modal');
    const inputField = document.getElementById('zipCodeModalInputField');

    // Bind events elements
    this.setZipCodeOnEnterKey(inputField);
    if (cancelButton) {
      cancelButton.addEventListener('click', this.handleZipModalCancelButton.bind(this));
    }
    if (submitButton) {
      submitButton.addEventListener('click', this.handleGoButtonClick.bind(this));
    }

    // Check if zipcode already in storage and open modal if needed
    this.checkIfZipCodeStoreValueExists(inputField);
  }

  /**
   * Handler for zip code modal cancel button
   * @returns {void}
   */
  handleZipModalCancelButton() {
    const {
      spartaSetCookie
    } = spartaGlobalFunctions;
    if (this.marketCookieValue) spartaSetCookie(this.marketExpCookieName, '', -1);
    this.storeZipInLocalStorage(this.zipSuppressVal);
    this.setZipInputField('', false);
    spartaUILayersUtility.closeLayer('zipSelectModalSpartaUILayer');
    this.marketRedirectToHome();
  }

  /**
   * On go button click, set zip code and market cookies if form is valid
   * @param {Object} event jQuery event object
   * @returns {undefined}
   */
  handleGoButtonClick(event) {
    const $button = $(event.target);
    const $form = $button.closest('form');
    const value = $form.find('input').val();
    if (this.isFormValid($form)) {
      this.storeZipInLocalStorage(value);
      if (value === this.zipSuppressVal) {
        this.setZipInputField('', false);
      } else {
        this.getAreaForZip(value);
        this.setZipInputField(value);
      }
      spartaUILayersUtility.closeLayer('zipSelectModalSpartaUILayer');
    }
  }

  /**
   * Check if zip code store value is '00000' or if user has clicked opt out link
   * @return {boolean} - returns true is zip code is set to '00000'
   */
  checkIfZipSuppressed() {
    return this.ccZipStoreVal === this.zipSuppressVal || this.marketOptOutValue === true;
  }

  /**
   * Check if zip code value exists in local storage.
   * If exists, set the market cookie.
   * If doesn't exist, open the modal.
   *
   * @param {HTMLElement} inputField - the input field of the modal
   * @return {undefined}
   */
  checkIfZipCodeStoreValueExists(inputField) {
    // if zip code value in store and is not '00000'
    if (this.ccZipStoreVal.length > 0 && !this.checkIfZipSuppressed()) {
      this.setZipInputField(this.ccZipStoreVal, false);
      // if market cookie doesn't exist &
      // the zip code hasn't been entered in past 24 hours or is referring from market page
      if (this.marketCookieValue.length <= 0 && !ZipCodeCcModule.zipCodeEnteredInPastDay()) {
        // if user has not chosen to 'opt out' of market area offers
        if (this.marketOptOutValue === false) {
          if (!this.isRefferingFromMarketPage) {
            ZipCodeCcModule.openZipCodeModal(inputField);
          } else {
            this.getAreaForZip(this.ccZipStoreVal);
          }
        }
      } else if (this.marketCookieValue.length <= 0) {
        this.unsetZipStorage();
        ZipCodeCcModule.openZipCodeModal(inputField);
      }
    } else if (!this.checkIfZipSuppressed() && !this.isMarketPage) {
      // if no zip code in store or market cookie && zip code value is not '00000'
      ZipCodeCcModule.openZipCodeModal(inputField);
    } else if (this.checkIfZipSuppressed() && !ZipCodeCcModule.zipCodeEnteredInPastDay()) {
      // if zip code modal was 'cancel'ed over a day ago, open modal
      ZipCodeCcModule.openZipCodeModal(inputField);
    }
  }

  /**
   * Allow enter key on input to click go button
   * @param {object} field - dom element
   * @return {undefined}
   */
  setZipCodeOnEnterKey(field) {
    field.addEventListener('keypress', event => {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.target.closest('form').querySelector('a').click();
      }
    });
  }

  /**
   * Bind validation rules that were declared in the JCR
   * Also allow for custom validation rules when a testFunction is defined in the JCR
   * @returns {undefined}
   */
  bindValidationRules() {
    const {
      $target
    } = this.settings;
    const formValidations = {};
    $target.find('[data-validation-rules]').each((index, field) => {
      const $field = $(field);
      const id = $field.attr('id');
      const rules = $field.data('validation-rules');
      const testFunctions = {};
      formValidations[id] = rules;
      if (rules.change && rules.change.customFunction) {
        const {
          testFunction,
          errorMessage
        } = rules.change.customFunction;
        formValidations[id].change.customFunction = {
          parameters: [testFunctions[testFunction].bind(this, $field)],
          errorMessage
        };
      }
      $field.removeAttr('data-validation-rules');
    });
    this.Validation.bindValidationRules(formValidations, true);
  }

  /**
   * Check if form is valid
   * @param {Object} $form jQuery DOM node
   * @returns {Boolean} Is form valid?
   */
  isFormValid($form) {
    const $input = $form.find('input');
    const isFormFilled = this.Validation.validateRequiredFields($input);
    if (!isFormFilled) {
      if (typeof bactm !== 'undefined' && typeof bactm.customError === 'function') {
        bactm.customError(400, 'Invalid Zip Code');
      }
      return false;
    }
    $input.trigger('change');
    if ($input.val().length !== 5) {
      spartaInputErrorUtility.updateInlineError(true, {
        field: $form.find('input'),
        label: $form.find('label'),
        message: 'Please enter a valid zip'
      });
      if (typeof bactm !== 'undefined' && typeof bactm.customError === 'function') {
        bactm.customError(400, 'Invalid Zip Code');
      }
      return false;
    }
    return true;
  }

  /**
   * Set default in zip code input
   * @param {*} zip - selected zip code
   * @param {boolean} focus - if true, brings zip code form in focus
   * @returns {undefined}
   */
  setZipInputField(zip, focus = true) {
    const input = this.target.querySelector('#zipCodeInputField');
    input.value = zip;
    if (focus) {
      input.focus();
      input.blur();
    }
  }

  /**
   * Get market area for zip code and use to set the cookie.
   * If no market for zip, unset the cookie if it exists.
   * Redirect after either to trigger WLM rules.
   *
   * @param {string} zipCode - zip code input field or store value
   * @return {undefined}
   */
  getAreaForZip(zipCode) {
    ZipCodeCcModule.getMarket(zipCode, marketName => {
      if (marketName && marketExpAreas[marketName]) {
        // Found a matching, active market for zipcode
        this.setMarketAreaCookie(marketName);
        ZipCodeCcModule.redirectToHome();
      } else if (!marketName || !marketExpAreas[marketName]) {
        // set market cookie to null if zip code is not in any market
        this.unsetMarketAreaCookie();
        this.storeZipInLocalStorage(this.zipSuppressVal);
        this.setZipInputField('', false);
        ZipCodeCcModule.redirectToHome();
      }
    });
  }

  /**
   * Sets the market area cookie to the area
   * returned from prior backend call
   *
   * @param {*} marketName - the market area name returned
   * @memberof ZipCodeCcModule
   * @returns {void}
   */
  setMarketAreaCookie(marketName) {
    const {
      spartaSetCookie
    } = spartaGlobalFunctions;
    if (sparta.env === 'local') {
      spartaSetCookie(this.marketExpCookieName, marketName, this.cookieExpiryTime);
    } else {
      spartaSetCookie(this.marketExpCookieName, marketName, this.cookieExpiryTime, true);
    }
  }

  /**
   * Unsets the market area cookie
   *
   * @memberof ZipCodeCcModule
   * @returns {void}
   */
  unsetMarketAreaCookie() {
    const {
      spartaSetCookie
    } = spartaGlobalFunctions;
    if (sparta.env === 'local') {
      spartaSetCookie(this.marketExpCookieName, '', MARKET_COOKIE_CLEAR);
    } else {
      spartaSetCookie(this.marketExpCookieName, '', MARKET_COOKIE_CLEAR, true);
    }
  }

  /**
   * Listen for zip code related events
   * @returns {void}
   */
  subscribeEvents() {
    spartaEventsUtility.sub(creditCardUtility.EVENTS.clearZipCodeCookie, () => {
      this.unsetMarketAreaCookie();
      this.marketRedirectToHome();
    }, true);
  }

  /**
   * Stores a zip code in local storage along with a time stamp
   * @memberof ZipCodeCcModule
   * @param {String} zipCode zip code to be stored
   * @returns {void}
   */
  storeZipInLocalStorage(zipCode) {
    spartaStoreUtility.persist(this.zipStoreName, zipCode);
    spartaStoreUtility.persist('zipTime', new Date());
  }

  /**
   * Unset the zipcode in local storage
   *
   * @memberof ZipCodeCcModule
   * @returns {void}
   */
  unsetZipStorage() {
    spartaStoreUtility.removePersisted(this.zipStoreName);
    spartaStoreUtility.removePersisted('zipTime');
  }

  /**
   * redirect handler for market pages
   * @returns {void}
   */
  marketRedirectToHome() {
    if (this.isMarketPage) {
      // check for spanish user
      if (sparta.language !== 'en') {
        window.location.href = `/credit-cards/${sparta.language}`;
      } else {
        window.location.href = '/credit-cards/';
      }
    }
  }

  /**
   * Initializer to create zip code modal chicken switch
   * Allows for manual opening/closing of the modal.
   * @returns {void}
   */
  initChickenSwitch() {
    // Modal 'chicken switch' to hide or show the modal
    this.settings.ZipCodeModal = document.querySelector('#zipSelectModal');
    window.ZipCodeCcModuleJS = {};
    window.ZipCodeCcModuleJS.close = () => {
      spartaUILayersUtility.closeLayer();
    };
    window.ZipCodeCcModuleJS.open = () => {
      ZipCodeCcModule.openZipCodeModal();
    };
  }

  /**
  |--------------------------------------------------
  | Static Methods
  |--------------------------------------------------
  */

  /**
   * Checks for the boa_geographic_data cookie.
   * If found, return the zipCode, otherwise return null
   * @memberof ZipCodeCcModule
   * @returns {String} zipCode
   */
  static checkForGeoCookie() {
    const {
      spartaGetCookie
    } = spartaGlobalFunctions;
    const geoCookie = spartaGetCookie('boa_geographic_data');
    if (geoCookie) {
      const zipCode = geoCookie.split('|')[0];
      return zipCode;
    }
    return null;
  }

  /**
   * Check markets object for a zipCode and return a match if exists or undefined
   * @param {string} zipCodeValue - zip code input field or store value
   * @param {method} cb - callback function to handle async data
   * @returns {void}
   */
  static getMarket(zipCodeValue, cb) {
    creditCardUtility.requestMarketWithZip({
      zip: zipCodeValue
    }).then(data => {
      if (data.market === null) {
        cb(undefined);
      } else {
        cb(data.market.toLowerCase());
      }
    });
  }

  /**
   * Redirect back to homepage for WLM Rule triggering
   * Check for language as well
   *
   * @static
   * @memberof ZipCodeCcModule
   * @returns {void}
   */
  static redirectToHome() {
    // check for spanish user
    if (sparta.language !== 'en') {
      window.location.href = `/credit-cards/${sparta.language}`;
    } else {
      window.location.href = '/credit-cards/';
    }
  }

  /**
   * Checks to see if the user has entered their zip code in the past day
   * @returns {Boolean} Was the zip code entered in the past 24 hours?
   * @memberof ZipCodeCcModule
   */
  static zipCodeEnteredInPastDay() {
    const now = new Date();
    const timeOfLastZipInput = new Date(spartaStoreUtility.getPersisted('zipTime'));

    // If zip code has never been entered
    if (!timeOfLastZipInput) return false;

    // 24 * 60 * 60 * 1000 = 86400000 Milliseconds in a day
    if (now - timeOfLastZipInput < 8.64e7) {
      return true;
    }
    return false;
  }

  /**
   * Method for opening zip code modal
   * @param {HTMLElement} focusField - optional field to focus when modal is opened
   * @returns {void}
   */
  static openZipCodeModal(focusField) {
    spartaUILayersUtility.openLayer('#zipSelectModal');
    if (focusField) focusField.focus();
    if (typeof bactm !== 'undefined' && typeof bactm.rescanDOM === 'function' && typeof bactm.pageview === 'function') {
      bactm.rescanDOM();
      bactm.pageview(1);
    }
  }
}
registerModuleClass({
  moduleClass: ZipCodeCcModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ZipCodeCcModule as default, moduleConfig };
